import React, { useState } from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { fileType } from "utils/helper";
import VideoMedia from "../ProductMedia/VideoMedia";
import nextArrow from "assets/images/next-arrow.svg";
import prevArrow from "assets/images/previous-arrow.svg";
import expandArrow from "assets/images/expand.svg";

import "swiper/swiper-bundle.css";

import styles from "./ImageSlider.module.scss";

SwiperCore.use([Navigation]);

const ImageSlider = ({ url, next, prev, expand = true, toggle }) => {
  const apikey = "oWMn7XZimqhCFQfptWtZWgwR";
  const imageSwiper = {
    slidesPerView: 1,
    navigation: {
      nextEl: `#${next}`,
      prevEl: `#${prev}`,
    },
    spaceBetween: 0,
    loop: false,
    initialSlide: 0,
  };

  let [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <Swiper
        {...imageSwiper}
        onSlideChange={(e) => setActiveIndex(e.realIndex)}
      >
        {url?.map((list, index) => {
          return (
            <SwiperSlide key={index}>
              <div className={styles.slider_image}>
                {fileType(list) == "mp4" ? (
                  <div className={styles.product_video}>
                    <VideoMedia url={list} />
                    <i
                      className="bi bi-play-circle"
                      onClick={() => toggle()}
                    ></i>
                  </div>
                ) : (
                  <img src={list} alt="" className={styles.product_img} />
                )}
                {expand && (
                  <img
                    src={expandArrow}
                    className={styles.expand}
                    onClick={() => toggle()}
                  />
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className={styles.image_slider_arrow}>
        <img src={prevArrow} id={prev} />
        <span>
          {activeIndex + 1} of {url?.length}
        </span>
        <img src={nextArrow} id={next} />
      </div>
    </>
  );
};

export default ImageSlider;
